<template>
  <div class="customize-line-container" :style="containerStyle">
    <div class="customize-line-title" :class="required && 'required'">
      <slot name="title">
        {{ title }}
      </slot>
    </div>
    <div class="customize-line-content" @click="handleClick">
      <slot />
    </div>
  </div>
</template>

<script>
export default _extend({
  name: 'CustomizeLine',
  props: {
    required: {
      type: Boolean,
      default: true
    },
    title: {
      type: String,
      default: ''
    },
    height: {
      type: Number
    }
  },
  methods: {
    handleClick() {
      this.$emit('click');
    }
  },
  computed: {
    containerStyle() {
      return this.height ? {
        height: this.height + 'px'
      } : {};
    }
  }
});
</script>

<style lang="scss" scoped>
@import './CustomizeLine.scss';
</style>



// WEBPACK FOOTER //
// src/components/NewComponents/CustomizeLine/CustomizeLine.vue